<template>
  <div>
    <div v-if="!isLoad" class="p-3">
      <div class="flex justify-end items-center">
        <div
          class="justify-end mr-4"
          :class="[$vuetify.breakpoint.lgAndUp ? 'flex' : 'flex-col']"
        >
          <v-col
            :cols="$vuetify.breakpoint.lgAndUp ? '' : '12'"
            :class="[$vuetify.breakpoint.lgAndUp ? '' : 'ml-auto']"
          >
            <v-text-field
              v-model="filterCustomer"
              label="Search by Customer"
              solo
              flat
              hide-details
              clearable
              outlined
              dense
              prepend-inner-icon="mdi-magnify"
              @input="handleInput"
            ></v-text-field>
          </v-col>
        </div>
        <v-tooltip top>
          <template #activator="{ on, attrs }">
            <v-btn
              @click="addNewCustomer"
              :color="$vuetify.theme.currentTheme.primary"
              class="ml-4 white--text"
              v-bind="attrs"
              v-on="on"
            >
              Add Customer
              <v-icon right dark>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Add Customer</span>
        </v-tooltip>
        <div :class="[$vuetify.breakpoint.lgAndUp ? '' : 'mr-auto']">
          <v-menu offset-y class="w-16">
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" class="ml-4">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                @click="handleShowDialogDelete()"
                :disabled="!selected.length"
              >
                <v-list-item-title>Bulk Delete</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>

      <div class="overflow-x-auto overflow-y-auto">
        <v-data-table
          :headers="headers"
          :items="customers"
          class="pl-7 pr-7 pt-4"
          fixed-header
          :footer-props="{ itemsPerPageOptions: [5, 10, 15, 30, 50] }"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="loadTable"
          v-model="selected"
          show-select
          item-key="_id"
        >
          <template v-slot:item.customerName="{ item }">
            <td
              class="px-4 py-6 font-semibold"
              @click="showCustomerDetails(item)"
            >
              {{ userFullName(item) }}
            </td>
          </template>
          <template v-slot:item.crn="{ item }">
            <td class="px-4 py-6 font-semibold">{{ item.crn }}</td>
          </template>
          <template v-slot:item.email="{ item }">
            <td class="px-4 py-6 font-semibold">{{ item.customerEmail }}</td>
          </template>
          <template v-slot:item.customerMobile="{ item }">
            <td class="px-4 py-6 font-semibold">
              {{ item.customerMobile[0] }}
            </td>
          </template>
          <template v-slot:item.address="{ item }">
            <td
              class="px-4 py-6 font-semibold"
              v-if="item.customerAddress.length"
            >
              {{ customerAddress(item.customerAddress[0]) || "-" }}
              <br />
              {{
                item.customerAddress[0]?.typeOfAddress
                  ? `(${item.customerAddress[0]?.typeOfAddress})`
                  : ""
              }}
            </td>
            <td v-else>-</td>
          </template>
          <template v-slot:item.action="{ item }">
            <td class="px-4 py-6">
              <action-button
                :item="item"
                :canEdit="true"
                :handleEdit="() => customerEdit(item)"
                :handleDelete="() => customerDelete(item)"
                :showDeleteButton="true"
                :canDelete="true"
              />
            </td>
          </template>
        </v-data-table>
      </div>
      <v-dialog v-model="openAddCustomer" width="43rem" persistent>
        <AddCustomer
          @customerAdded="handleNewCustomer"
          :editCustomer="editCustomer"
          :caseType="relatedCaseType"
        />
      </v-dialog>
      <v-dialog v-model="showCustomerDetailsPopup" max-width="800">
        <CustomerDetails
          :customer="selectedCustomer"
          :closeCustomerPopUp="closeCustomerPopUpFunc"
        />
      </v-dialog>
      <v-dialog v-model="whatsAppMessagePopupVisible" max-width="500">
        <WhatsAppMessage :customers="selected" />
      </v-dialog>
      <AlertPopUp
        :showConfirmationDialog="showConfirmationDialog"
        :confirmationTitle="'Confirm Delete'"
        :confirmationMessage="'Are you sure you want to delete the customer?'"
        :confirmationActionText="'DELETE'"
        :confirmationActionColor="'red'"
        :performAction="custDeleteAction"
        :cancel="cancelDelete"
      />
      <AlertPopUp
        :showConfirmationDialog="showDeleteDialog"
        :confirmationTitle="'Confirm Delete'"
        :confirmationMessage="'Do you want to delete selected customer?'"
        :confirmationActionText="'DELETE'"
        :confirmationActionColor="'red'"
        :performAction="customerDeleteFunc"
        :cancel="handleShowDialogDelete"
        :loading="loading"
      />
    </div>
    <div
      v-else
      class="absolute w-full h-screen flex-col items-center flex justify-center"
    >
      <v-progress-circular
        :color="$vuetify.theme.currentTheme.primary"
        indeterminate
        :size="50"
        :width="5"
      ></v-progress-circular>
      <div class="mt-2"><span>Please Wait...</span></div>
    </div>
  </div>
</template>
<script>
import AddCustomer from "@/components/Workforce/CollectionModules/AddCollCustomer";
import CustomerDetails from "@/components/Workforce/CollectionModules/CustomerDetails";
import AlertPopUp from "@/components/AlertPopUp";
import { fullName, getFullAddress, debounce } from "@/utils/common";
import ActionButton from "@/components/ActionButton.vue";
import WhatsAppMessage from "@/components/Workforce/WhatsAppTemplateMessage.vue";
export default {
  name: "CollectionCustomer",
  layout: "Workforce/default",
  components: {
    ActionButton,
    AddCustomer,
    CustomerDetails,
    AlertPopUp,
    WhatsAppMessage,
  },
  props: {
    caseConfig: Object,
  },
  data() {
    return {
      openAddCustomer: false,
      whatsAppMessagePopupVisible: false,
      loadTable: false,
      showCustomerDetailsPopup: false,
      customers: [],
      editCustomer: null,
      options: { itemsPerPage: 5, page: 1 },
      selectedCustomer: null,
      deleteCustomer: null,
      totalItems: 0,
      filterCustomer: "",
      showConfirmationDialog: false,
      headers: [
        { text: "Customer Name", value: "customerName", sortable: false },
        { text: "CRN", value: "crn", sortable: false },
        { text: "Email", value: "email", sortable: false },
        { text: "Phone No", value: "customerMobile", sortable: false },
        { text: "Address", value: "address", sortable: false },
        { text: "Action", value: "action", sortable: false },
      ],
      selected: [],
      showDeleteDialog: false,
      loading: false,
      isLoad: true,
    };
  },
  watch: {
    options: {
      handler() {
        this.fetchCustomers();
      },
      deep: true,
    },
  },
  computed: {
    relatedCaseType() {
      return this.$props.caseConfig?.name || "";
    },
  },
  methods: {
    closeCustomerPopUpFunc() {
      this.showCustomerDetailsPopup = false;
    },
    async fetchCustomers() {
      try {
        this.loadTable = true;
        const { page, itemsPerPage } = this.options;
        const params = {
          page,
          limit: itemsPerPage > -1 ? itemsPerPage : this.totalItems,
          relatedCategory: this.relatedCaseType ? "collection" : undefined,
          relatedSubCategories: this.relatedCaseType || undefined,
        };
        if (this.filterCustomer) {
          params.search = this.filterCustomer;
        }

        const response = await this.$axios.get("/workforce/customers", {
          params,
        });
        this.customers = response.data.customers;
        this.loadTable = false;
        this.totalItems = response.data?.pagination?.totalCount;
      } catch (error) {
        console.log(error);
        const errorMessage = error.response.data.message || error;
        this.$toast.error(errorMessage);
        this.loadTable = false;
      }
    },
    customerDelete(item) {
      this.deleteCustomer = item;
      this.showConfirmationDialog = true;
    },
    userFullName(item) {
      if (item.customerFullName) {
        return item.customerFullName;
      } else if (item.firstName) {
        return fullName(item);
      } else {
        return "";
      }
    },
    async custDeleteAction() {
      try {
        const item = this.deleteCustomer;
        const response = await this.$axios.delete(
          `/workforce/customer/${item._id}`
        );
        const index = this.customers.findIndex((cust) => cust._id === item._id);
        if (index !== -1) {
          this.customers.splice(index, 1);
        }
        const successMessage =
          response?.data?.message || "Customer deleted successfully.";
        this.$toast.success(successMessage);
        this.cancelDelete();
      } catch (error) {
        const errorMessage =
          error.response.data.message ||
          "An error occurred while deleting the customer.";
        this.$toast.error(errorMessage);
        console.error(error);
      }
    },
    async singleCustomerDelete(item) {
      try {
        let response = await this.$axios.delete(
          `/workforce/customer/${item._id}`
        );
        return response.data;
      } catch (error) {
        console.error(error);
      }
    },
    async customerDeleteFunc() {
      this.loading = true;

      const promises = [];

      // Make API calls and store promises in the array
      this.selected?.forEach(async (item) => {
        promises.push(this.singleCustomerDelete(item));
      });

      // Wait for all API calls to complete
      try {
        const results = await Promise.all(promises);

        if (!results.includes(undefined)) {
          this.$toast.success("Customers deleted successfully.");
        }
        this.loading = false;
        this.selected = [];
        this.handleShowDialogDelete(false);
      } catch (error) {
        this.$toast.error("An error occurred while deleting the case.");
        console.error(error);
      }
    },
    cancelDelete() {
      this.showConfirmationDialog = false;
      this.deleteCustomer = null;
      this.fetchCustomers();
    },
    customerEdit(item) {
      this.editCustomer = item;
      this.openAddCustomer = true;
    },
    customerAddress(item) {
      if (item) {
        return getFullAddress(item);
      }
      return "-";
    },
    addNewCustomer() {
      this.editCustomer = null;
      this.openAddCustomer = true;
    },
    handleNewCustomer() {
      this.openAddCustomer = false;
      this.fetchCustomers();
    },
    showCustomerDetails(customer) {
      this.selectedCustomer = customer;
      this.showCustomerDetailsPopup = true;
    },
    handleInput: debounce(async function () {
      this.options.page = 1;
      await this.fetchCustomers();
    }, 800),

    handleShowDialogDelete() {
      this.showDeleteDialog = !this.showDeleteDialog;
      if (this.showDeleteDialog === false) {
        this.fetchCustomers();
      }
    },
  },
  mounted() {
    this.fetchCustomers();
    this.isLoad = false;
  },
};
</script>
<style scoped>
.v-data-table
  >>> .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td
  > .v-data-table__checkbox {
  text-align: center;
}
</style>
